import React from 'react';
import { Divider, Typography } from '@mui/material';

import { MaterialPropertyValuePair } from '@paragon/client-tools';
import { Lumber } from '@paragon/contract-library';

import { getLumberPropertySetsKeyed } from '../../../../store/selectors/getLumberPropertySetsKeyedSelector';
import { getLumberPropertySetKey } from '../../../../store/slices/lumberPropertySetsSlice';
import { useAppSelector } from '../../../hooks';

type Props = {
  lumber: Lumber;
};

export const LumberDesignValues = (props: Props) => {
  const lumberPropertySetsKeyed = useAppSelector(getLumberPropertySetsKeyed);
  const lumberPropertySetKey = getLumberPropertySetKey(props.lumber);
  const lumberPropertySet = lumberPropertySetsKeyed[lumberPropertySetKey];
  return (
    <>
      <Typography variant="subtitle1" sx={{ marginTop: 2 }}>
        Design Values
      </Typography>
      <Divider />

      <MaterialPropertyValuePair
        sx={{ m: 1 }}
        property="Bending"
        value={lumberPropertySet ? lumberPropertySet.bending : 'Not Loaded'}
      />
      <MaterialPropertyValuePair
        sx={{ m: 1 }}
        property="Compression Parallel To Grain"
        value={lumberPropertySet ? lumberPropertySet.compressionParallelToGrain : 'Not Loaded'}
      />
      <MaterialPropertyValuePair
        sx={{ m: 1 }}
        property="Compression Perpendicular To Grain"
        value={lumberPropertySet ? lumberPropertySet.compressionPerpendicularToGrain : 'Not Loaded'}
      />
      <MaterialPropertyValuePair
        sx={{ m: 1 }}
        property="Modulus Of Elasticity"
        value={lumberPropertySet ? lumberPropertySet.modulusOfElasticity : 'Not Loaded'}
      />
      <MaterialPropertyValuePair
        sx={{ m: 1 }}
        property="Modulus Of Elasticity Min"
        value={lumberPropertySet ? lumberPropertySet.modulusOfElasticityMin : 'Not Loaded'}
      />
      <MaterialPropertyValuePair
        sx={{ m: 1 }}
        property="Shear Parallel To Grain"
        value={lumberPropertySet ? lumberPropertySet.shearParallelToGrain : 'Not Loaded'}
      />
      <MaterialPropertyValuePair
        sx={{ m: 1 }}
        property="Specific Gravity"
        value={lumberPropertySet ? lumberPropertySet.specificGravity : 'Not Loaded'}
      />
      <MaterialPropertyValuePair
        sx={{ m: 1 }}
        property="Tension Parallel To Grain"
        value={lumberPropertySet ? lumberPropertySet.tensionParallelToGrain : 'Not Loaded'}
      />
    </>
  );
};
